<form [formGroup]="distributionAccountEditForm" (submit)="edit()" id="form-edit-distribution-account">
  <button mat-icon-button
          id="button-dialog-close"
          class="mat-icon-button-small"
          data-cy="button-dialog-close"
          [mat-dialog-close]="true">
    <mat-icon>clear</mat-icon>
  </button>
  <h5 mat-dialog-title>Edit Distribution Account</h5>
  <div mat-dialog-content class="mat-body-1">
    <p>Edit a Distribution Account.</p>
    <p *ngIf="errorMessage" class="error" id="error-feedback">{{errorMessage}}</p>
    <mat-form-field id="distribution-account-description-form">
      <input #distributionAccountDescription
             formControlName="description"
             class="form-input"
             id="distribution-account-description"
             matInput
             maxlength="500"
             name="distribution-account-description"
             placeholder="Distribution Account Description">
      <mat-hint align="end">{{distributionAccountDescription.value.length || 0}} / 500</mat-hint>
      <mat-error id="description-error" *ngIf="distributionAccountEditForm?.get('description')?.hasError('required')">
        Distribution account description is empty
      </mat-error>
    </mat-form-field>

    <app-input-dropdown
      id="partner-id-dropdown"
      elementId="partner-id-form"
      [data]="partners"
      [inputControl]="partnerIdControl"
      label="Partner"
      orderByValue="partnerId"
      placeholder="Partner">
    </app-input-dropdown>
  </div>

  <div mat-dialog-actions>
    <button type="submit" color="primary" id="button-edit-distribution-account" mat-raised-button>Edit</button>
  </div>
</form>
